import {
  ActionItem,
  ActionItemMultiSelect,
  ActionMenu,
  FilterButton,
  useActionMenu,
} from '@moia-dev/pace-web'
import { useState } from 'react'

type MultiSelectFilterProps = {
  label: string
  clearLabel: string
  options: { value: string; label: string }[]
  selectedOptions: string[]
  setSelectedOptions: (values: string[]) => void
}

/**
 * Checkbox dropdown for the saved-routes filter row, following
 * `trip-history/TripList/MultiSelectFilter.tsx`. Kept local rather than imported
 * across areas, like the annotation-triage copy.
 */
export const MultiSelectFilter = ({
  label,
  clearLabel,
  options,
  selectedOptions,
  setSelectedOptions,
}: MultiSelectFilterProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { getReferenceProps, ...menuProps } = useActionMenu({
    isOpen,
    setIsOpen,
  })

  const toggle = (value: string) =>
    setSelectedOptions(
      selectedOptions.includes(value)
        ? selectedOptions.filter(selected => selected !== value)
        : [...selectedOptions, value],
    )

  const selectedLabels = selectedOptions.map(
    value => options.find(option => option.value === value)?.label ?? value,
  )

  return (
    <>
      <FilterButton
        {...getReferenceProps({ onClick: () => setIsOpen(!isOpen) })}
        ref={menuProps.refs.setReference}
        label={label}
        values={selectedLabels}
        disabled={options.length === 0 && selectedOptions.length === 0}
        onDelete={
          selectedOptions.length > 0 ? () => setSelectedOptions([]) : undefined
        }
        css={{ flexShrink: 0 }}
      />
      <ActionMenu {...menuProps}>
        {options.map(option => (
          <ActionItemMultiSelect
            key={option.value}
            label={option.label}
            selected={selectedOptions.includes(option.value)}
            onClick={() => toggle(option.value)}
          />
        ))}
        {selectedOptions.length > 0 && (
          <ActionItem
            label={clearLabel}
            onClick={() => setSelectedOptions([])}
          />
        )}
      </ActionMenu>
    </>
  )
}
